import React from 'react';
import { concatStyles } from '../../utils/styleHelpers';
import ChevronRightIcon from './ChevronRightIcon';
export default function BreadcrumbElement({ path, groupId, breadcrumb, isCurrentPage = false, onClick, }) {
    // If it's a parent breadcrumb but doesn't have a path and label OR
    // It is a current page and it doesn't have a label, don't render.
    if ((!isCurrentPage && !path && !breadcrumb) || (isCurrentPage && !breadcrumb)) {
        return null;
    }
    const handleClick = () => {
        if (onClick && groupId) {
            onClick(groupId);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: concatStyles('cio-plp-breadcrumb', !isCurrentPage && 'cio-plp-parent-breadcrumb') }, !isCurrentPage ? (React.createElement("button", { type: 'button', onClick: handleClick }, breadcrumb)) : (React.createElement("span", null, breadcrumb))),
        !isCurrentPage && React.createElement(ChevronRightIcon, null)));
}
